import { render, staticRenderFns } from "./histogram.vue?vue&type=template&id=8af6c016"
import script from "./histogram.vue?vue&type=script&lang=js"
export * from "./histogram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports